<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="text-h6">
					<span>Detail Response API</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="3" md="3">
							<div class="text-subtitle-1 font-weight-bold">Tanggal</div>
							<div class="pt-1">{{responseApiDetail.response_api_datetime | tanggaljam}}</div>
						</v-col>
						<v-col cols="1" md="1">
							<div class="text-subtitle-1 font-weight-bold">Tipe</div>
							<div class="pt-1">{{responseApiDetail.response_api_type}}</div>
						</v-col>
						<v-col cols="7" md="7">
							<div class="text-subtitle-1 font-weight-bold">Endpoint</div>
							<div class="pt-1">{{responseApiDetail.response_api_endpoint}}</div>
						</v-col>
						<v-col cols="1" md="1">
							<div class="text-subtitle-1 font-weight-bold">Kode</div>
							<div class="pt-1">{{responseApiDetail.response_api_status_code}}</div>
						</v-col>
					</v-row>
					<v-row class="">
						<v-col cols="12" md="12">
							<v-list color="deep-purple lighten-5" class="pa-1" rounded>
								<v-list-item dense class="px-1 justify-center">
									<div class="font-weight-bold text-uppercase primary--text">Parameter</div>
								</v-list-item>
							</v-list>
						</v-col>
						<v-col cols="12" md="12">
							<v-card class="mb-1 elevation-0">
								<v-textarea
									readonly
									hide-details
									outlined
									background-color="deep-purple lighten-5"
									:rows="paramsHeight"
									v-model="responseApiParams"
								/>
							</v-card>
						</v-col>
						<v-col cols="12" md="12">
							<v-list color="deep-purple lighten-5" class="pa-1" rounded>
								<v-list-item dense class="px-1 justify-center">
									<div class="font-weight-bold text-uppercase primary--text">Respon</div>
								</v-list-item>
							</v-list>
						</v-col>
						<v-col cols="12" md="12">
							<v-card class="mb-1 elevation-0">
								<v-textarea
									readonly
									hide-details
									outlined
									background-color="deep-purple lighten-5"
									:rows="resultHeight"
									v-model="responseApiResult"
								/>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			singleSelect: false,
		}
	},
	computed:{
		...mapState('responseApi', ['responseApiDetail']),

		responseApiParams(){
			return this.detailResponseApi.response_api_params == undefined ? '' : JSON.stringify(JSON.parse(this.detailResponseApi.response_api_params), null, '\t')
		},
		responseApiResult(){
			try {
				return this.detailResponseApi.response_api_result == undefined ? '' : JSON.stringify(JSON.parse(this.detailResponseApi.response_api_result), null, '\t')
			} catch(e) {
				return this.detailResponseApi.response_api_result == undefined ? '' : this.detailResponseApi.response_api_result
			}
		},
		paramsHeight(){
			return this.responseApiParams.split(/\r\n|\r|\n/).length
		},
		resultHeight(){
			return this.responseApiResult.split(/\r\n|\r|\n/).length
		},
	},
	created() {
	},
	props: {
		dialog: Boolean,
		detailResponseApi: Object,
	},
	methods :{
		hideDialog(){
			this.$emit('hideDialog')
		},
	}
};
</script>
